/**
 * create by Taobao dev team 18/1/2018
 */
import React, {Component} from 'react'
import DocumentTitle from "react-document-title"
import _ from 'lodash';
import lodash from 'lodash';
import ProgressBar from '../Spinner/ProgressBar';
import {LocalStore} from "../../utils/LocalStore";
import UserServices from '../../services/user.service';
import {Link} from 'react-router-dom';
import {Avatar, Button, Checkbox, Col, Divider, Layout, Modal, Popover, Row} from 'antd';
import * as AntdIcon from "@ant-design/icons"

import {withNamespaces} from 'react-i18next';

import Notifications from '../Notifications'
// import Notifications from '../Notifications/Notification_bak'
import TotalSkusInCart from '../Carts/TotalSkusInCart'
import Balance from '../Profile/Balance'
import Language from '../Language';
import MenuContainer from '../Menu'
import CategoriesService from "../../services/categories.service";
import {linkify, moneyFormat} from "../../utils/stringUtils";
import moment from "moment";

const PERCENT_COMPLETE = 100;

class MainLayout extends Component {

    static defaultProps = {
        isLoadingPopup: false,
        isFocusSubmit: false
    };

    constructor(props) {
        super(props);
        this.isUnmounted = false;
        this.state = {
            baseCurrency: 'CNY',
            targetCurrency: 'VND',
            collapsed: true,
            currentLoggedUser: {},
            percent: -1,
            autoIncrement: false,
            intervalTime: 200,
            // isMobile: window.innerWidth < 981,
            // isTablet: window.innerWidth < 1025,
        };
        // this.TotalSkusInCart = React.createRef();
        this.BalanceComponent = React.createRef();
    }

    // scroll top khi bắt đầu load trang
    componentDidMount() {
        window.scrollTo(0, 0);
        // window.addEventListener('resize', this.windowResize);
        this.setState({
            currentLoggedUser: LocalStore.getInstance().read('currentLoggedUser') || {},
            articleList: _.sortBy(LocalStore.getInstance().read('articleList'), 'publishDate').reverse() || [],
            currentArticle: _.sortBy(LocalStore.getInstance().read('articleList'), 'publishDate').reverse()[0],
            articleSeen: LocalStore.getInstance().read('articleSeen'),
            articleShow: LocalStore.getInstance().read('articleShow'),
        });

        if (typeof LocalStore.getInstance().read('currentProjectInfo') === 'object') {
            this.setState({
                currentProjectInfo: LocalStore.getInstance().read('currentProjectInfo') || {}
            },()=>{
                this.getMenuFooter()
            });
        }

    }

    getMenuFooter = () => {
        CategoriesService.getMenuFooter((err, res) => {
            if (!err) {
                this.setState({
                    menuFooter: res || []
                })
            }
        });
    };

    componentWillUnmount() {
        this.isUnmounted = true;
        // window.removeEventListener('resize', this.windowResize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.showProgressBar !== this.props.showProgressBar) {
            // hiển thị progress bar
            if (this.props.showProgressBar === true) {
                this.startWithAutoIncrement();
            } else {
                // this.stopWithAutoIncrement();
                this.setPercent(PERCENT_COMPLETE);
            }
        }
    }

    // /**
    //  * khi window resize
    //  */
    // windowResize = () => {
    //     const windowWidth = window.innerWidth;
    //     if (!this.isUnmounted) this.setState({
    //         isMobile: windowWidth < 981,
    //         isTablet: windowWidth < 1025
    //     })
    // };

    /**
     * hiển thị progressbar
     **/
    startWithAutoIncrement = () => {
        this.setState({
            percent: 0,
            autoIncrement: true,
            intervalTime: (Math.random() * 150)
        });
    };

    /**
     * Dừng progressbar
     **/
    stopWithAutoIncrement = () => {
        setTimeout(() => {
            this.setState({
                percent: -1,
                autoIncrement: false,
                intervalTime: 150
            });
        }, 500);
    };

    setPercent = (percent) => {
        this.setState({
            percent: percent
        }, () => {
            if (percent === PERCENT_COMPLETE) {
                this.stopWithAutoIncrement();
            }
        });
    };

    logout = () => {
        UserServices.logout()
    };

    renderDropDownAvatar = () => {
        const {t} = this.props;
        return <div className='popover-profile-content'>
            <Link to={'/profile'} className="_popover-profile_profile txt-size-h8 popover-profile-content-item txt-color-black dpl-block mgbt10 pdl15 pdr20">
                <AntdIcon.UserOutlined type={""} style={{fontSize: 12}} className="mgr10"/> {t('customer_info.personal_info')}
            </Link>
            {/*<a className="_popover-profile_vippoint txt-size-h8 popover-profile-content-item txt-color-black dpl-block mgbt10 pdl15 pdr20" href="/"><Icon component={iconVipPoint} style={{fontSize: 12}} className="mgr10"/> Điểm tích lũy</a>*/}
            {/*<a className="_popover-profile_charge txt-size-h8 popover-profile-content-item txt-color-black dpl-block pdl15 pdr20" href="/"><Icon component={iconCharge} style={{fontSize: 12}} className="mgr10"/> Nạp tiền</a>*/}
            <Divider style={{marginBottom: 10, marginTop: 10}}/>
            <span onClick={this.logout} className="_logout-btn popover-profile-content-item txt-color-black txt-size-h8 cursor-pointer dpl-block pdl15 pdr20">
                <AntdIcon.LogoutOutlined type={""} style={{fontSize: 12}} className="mgr10"/> {t('login.logout_btn')}
            </span>
        </div>
    };

    renderMenu = () => {
        const {menuFooter = []} = this.state;

        return (<div className='pdr10 pdl10'>
            {
                menuFooter.map((item, index) => {
                    return (<div key={index}>
                        {
                            index!==0 && <Divider key={`device${index}`} style={{marginBottom: 10, marginTop: 10}}/>
                        }
                        <a href={item.href} target={item.target || '_blank'} key={index} className={`cursor-pointer dpl-block txt-color-gray`}>
                            <div className={'txt-size-h8 robotoregular'}>{item.name}</div>
                        </a>
                    </div>);
                })
            }
        </div>);
    };

    renderModalArticle = () => {
        const {t} = this.props;
        const {articleList = [], articleSeen, currentArticle = {}, articleShow, notShowAgain} = this.state;
        return <Modal
            className=""
            width={800}
            title={<div>
                <div>{currentArticle.title}</div>
                <div className="txt-size-h8 txt-color-gray2">{moment(currentArticle.publishDate).format('HH:mm DD/MM/YYYY')}</div>
            </div>}
            visible={!articleSeen && articleList.length > 0 && articleShow}
            onCancel={() => {
                if (notShowAgain) {
                    this.setState({articleSeen: true}, () => {
                        LocalStore.getInstance().save('articleSeen', true);
                    })
                } else {
                    this.setState({articleShow: false}, () => {
                        LocalStore.getInstance().save('articleShow', false);
                    })
                }
            }}
            footer={[
                <Button
                    onClick={() => {
                        if (notShowAgain) {
                            this.setState({articleSeen: true}, () => {
                                LocalStore.getInstance().save('articleSeen', true);
                            })
                        } else {
                            this.setState({articleShow: false}, () => {
                                LocalStore.getInstance().save('articleShow', false);
                            })
                        }
                    }}
                    className="pdl30 pdr30"
                    type="primary"
                >
                    {t('button.close')}
                </Button>
            ]}
        >

            <div className="carousel-article">
                {
                    articleList.map((item, index) => <div className={`item-carousel-article ${currentArticle.id === item.id && 'active'}`} key={index}>
                        <div
                            className={`box-article txt-color-black txt-size-h7 robotoregular white-space-pre-wrap break-word max-width-100pc`}
                            dangerouslySetInnerHTML={{__html: linkify(item.content)}}
                        />
                    </div>)
                }
                <div className="carousel-article-control-bar">
                    {
                        articleList.map((item, index) => <div
                            key={index}
                            onClick={() => this.setState({currentArticle: item})}
                            className={`cursor-pointer carousel-article-control-bar-item ${currentArticle.id === item.id && 'active'}`}
                        />)
                    }
                </div>
            </div>
            <div className="dpl-flex justify-content-between align-items-center mgt20">
                <Checkbox onChange={(checked) => this.setState({notShowAgain: checked})} className="mgr10">{t('message.not_show_again')}</Checkbox>
            </div>
        </Modal>
    };

    changeVersion = () => {
        let split = window.location.href.split(window.location.origin);
        LocalStore.getInstance().save('currentVer', "mobile");
        if (split[1].indexOf('/m') !== 0) {
            window.location.href = window.location.origin + '/m' + split[1];
        }
    };

    renderFooter = () => {
        const {t} = this.props;
        const {currentProjectInfo = {}} = this.state;
        const generalConfig = currentProjectInfo.tenantConfig ? currentProjectInfo.tenantConfig.generalConfig : {};

        return <div>
            <div className="pdl30 pdr30 pdt20 pdbt20">
                <Row gutter={50}>
                    <Col span={6}>
                        <div className="footer-item-head">
                            <AntdIcon.MailOutlined type="mail" className='pdr5'/> {t('footer.contact')}
                        </div>

                        {
                            !!generalConfig.emailContact && <div className="dpl-flex pdbt5">
                                <div className="txt-color-gray">
                                    Email:
                                </div>
                                <div className="txt-color-black pdl5">
                                    {generalConfig.emailContact}
                                </div>
                            </div>
                        }

                        {
                            Array.isArray(generalConfig.phoneContacts) && generalConfig.phoneContacts.length > 0 && <div className="dpl-flex pdbt5">
                                <div className="txt-color-gray">
                                    {t('footer.phone')}:
                                </div>
                                <div className="txt-color-black pdl5">
                                    {
                                        generalConfig.phoneContacts.map((item, index) => <div key={index} className="pdbt3 line-underline">{item}</div>)
                                    }
                                </div>
                            </div>
                        }

                    </Col>

                    <Col span={6}>
                        <div className="footer-item-head">
                            <AntdIcon.HomeOutlined type="home" className='pdr5'/> {t('footer.address')}
                        </div>
                            <div  className="dpl-flex txt-color-black txt-size-h7 pdbt5">
                                {/*<Icon type="arrow-right" className="flex-none pdt3"/>*/}
                                <div className="">{lodash.get(generalConfig,'addressContact','')}</div>
                            </div>
                    </Col>

                    <Col span={6}>
                        <div className="footer-item-head">
                            <AntdIcon.BankOutlined type="bank" className='pdr5'/> {t('footer.bank_info')}
                        </div>

                        <div  className="dpl-flex txt-color-black txt-size-h7 pdbt5">
                            {/*<Icon type="arrow-right" className="flex-none pdt3"/>*/}
                            <div className="">{lodash.get(generalConfig,'bankAccount','')}</div>
                        </div>
                    </Col>

                    <Col span={6} className="txt-center pdt20">
                        <a
                            onClick={this.changeVersion}
                            className="_btn-change-version ant-btn ant-btn-primary bg-color-white txt-color-blue cursor-pointer position-re pdr20 pdl20"
                        >
                            <AntdIcon.MobileOutlined type="mobile" /> {t('footer.change_mobile_version')}
                        </a>
                    </Col>
                </Row>
            </div>
            <div className="pd10 text-center footer-bottom">
                Copyright ©
                2019 {currentProjectInfo && currentProjectInfo.domain ? currentProjectInfo.domain : 'nhaphang.com'} - {currentProjectInfo && currentProjectInfo.description}.
                Powered By Gobiz.

                {/*<a*/}
                {/*    onClick={this.changeVersion}*/}
                {/*    className="_btn-change-version ant-btn ant-btn-primary bg-color-white txt-color-blue cursor-pointer position-re pdr20 pdl20 mgl15"*/}
                {/*>*/}
                {/*    <Icon type="mobile" /> {t('footer.change_mobile_version')}*/}
                {/*</a>*/}
            </div>
        </div>
    };

    render() {
        const { t, title, children, headerTitle, noFooter, balance, totalSkus, exchangeRateObj} = this.props;
        const {
            percent, autoIncrement, intervalTime, currentLoggedUser, currentProjectInfo = {},
            collapsed,
            menuFooter = []
        } = this.state;

        let exchangeRate = exchangeRateObj ? [exchangeRateObj] : LocalStore.getInstance().read('exchangeRates') || [];
        const rate = exchangeRate[0];
        const tenantConfig = currentProjectInfo.tenantConfig || {};

        const orderConfig = tenantConfig.orderConfig || {};
        const shipmentConfig = tenantConfig.shipmentConfig || {};

        const homePageLink = _.get(currentProjectInfo, 'tenantConfig.internalLink.poseidon.landing')

        return (
            <DocumentTitle
                title={`${title ? title + ' | ' : ''} ${currentProjectInfo && currentProjectInfo.name ? currentProjectInfo.name : 'Loading...'}`}>
                <Layout
                    className={`${collapsed ? 'menu-collapsed' : ''} min-width-page position-re`}>

                    <Layout.Sider
                        trigger={null}
                        collapsible={true}
                        collapsed={collapsed}
                        className={"sidebarleft"}
                        onMouseOver={() => this.setState({
                            collapsed: false
                        })}
                        onMouseLeave={() => this.setState({
                            collapsed: true
                        })}
                    >
                        <div className="sidebarleft__logo">
                            <a href={currentProjectInfo.domain ? `//${currentProjectInfo.domain}` : '#'} target="_blank"
                               className='sidebarleft__logo_menu'>
                                <img
                                    src={currentProjectInfo.tenantConfig ? currentProjectInfo.tenantConfig.logoLite : ''}/>
                            </a>
                            <a href={currentProjectInfo.domain ? `//${currentProjectInfo.domain}` : '#'} target="_blank"
                               className='sidebarleft__logo_collapsed dpl-none'>
                                <img
                                    src={currentProjectInfo.tenantConfig ? currentProjectInfo.tenantConfig.logoLite : ''}/>
                            </a>
                        </div>
                        <MenuContainer {...this.props} collapsed={collapsed}/>
                    </Layout.Sider>
                    <div className="ant-layout" id={'scrollLayoutElement'} ref={ref => this.scrollLayoutElement = ref}>
                        <Layout.Header className={"header mgbt20"}>
                            <div className={'container'}>
                                <div
                                    className={'dpl-flex justify-content-between mgr20 border-bottom-1x bd-color-gray3'}>
                                    <div className={'header__left dpl-flex pdt20'}>
                                        <h2 className={'txt-size-h2 txt-color-black robotomedium line-height134'}>{headerTitle}</h2>
                                    </div>
                                    <div className={'header__right dpl-flex align-items-center'}>
                                        {
											homePageLink &&
                                            <div className={'header__right_item txt-color-gray mgr25'}>
                                                <a href={homePageLink} target="_blank"
                                                   className={'_header-exchange-rate txt-color-gray robotoregular txt-size-h8'}>
                                                    {t('header.homepage')}
                                                </a>
                                            </div>
                                        }

                                        {menuFooter.length > 0 &&

                                            <div className={'header__right_item txt-color-gray mgr25 cursor-pointer'}>
                                                <Popover
                                                    overlayClassName="popup-profile"
                                                    content={this.renderMenu()}
                                                    visible={this.state.visibleLinkSupport}
                                                    onVisibleChange={(visible) => this.setState({visibleLinkSupport: visible})}
                                                    placement="bottomRight" trigger="click"
                                                >
                                                    <div className='txt-size-h8 txt-color-gray robotoregular line-height167'>{t('header.support')} <AntdIcon.DownOutlined type="down" style={{fontSize: '10px'}}/></div>
                                                </Popover>
                                            </div>
                                        }

                                        {
                                            !orderConfig.disable && <div className={'header__right_item txt-color-gray mgr25 dpl-flex'}>
                                                <Link to={'/carts'} className={'_link-to-carts'}>
                                                <span className={'mgr5'}>
                                                    <AntdIcon.ShoppingCartOutlined className="txt-color-red txt-size-h5" type="shopping-cart"/>
                                                </span>
                                                </Link>
                                                <Link to={'/carts'}>
                                                    <h3 className={"txt-size-h8 txt-color-gray robotoregular"}>{t('header.cart')}
                                                        <TotalSkusInCart totalSkus={totalSkus} ref={ref => this.TotalSkusInCart = ref}/> {t('header.product')}
                                                    </h3>
                                                </Link>
                                            </div>
                                        }
                                        {
                                            (shipmentConfig.enable || !orderConfig.disable) && rate && exchangeRate.length < 2 && <div className={'header__right_item txt-color-gray mgr25'}>
                                                <span
                                                    className={"txt-size-h8 txt-color-gray robotoregular"}>{t('header.exchange')}</span>
                                                <span
                                                    className={'_header-exchange-rate txt-color-black robotoregular txt-size-h7 mgl5'}>
                                                    {moneyFormat(1, rate.base)} = {moneyFormat(rate.rate, rate.exchange)}
                                                </span>
                                            </div>
                                        }
                                        <Language {...this.props}/>
                                        <div className={'txt-color-gray mgr25'}>
                                            <Notifications {...this.props}/>
                                        </div>
                                        <Popover overlayClassName="popup-profile" content={this.renderDropDownAvatar()}
                                                 placement="bottomRight" trigger="click">
                                            <div className={'drop-down-user cursor-pointer dpl-flex'}>
                                                <Avatar src={currentLoggedUser.avatar} className={'bg-color-blue3'}/>
                                                <div className="_user-title pdl10 ">
                                                    <p className={'_user-name mgbt5 line-height-1 txt-size-h7 robotomedium txt-color-black'}>{currentLoggedUser.fullname}</p>
                                                    <Balance balance={balance} ref={this.BalanceComponent}/>
                                                </div>
                                            </div>
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                        </Layout.Header>
                        <ProgressBar
                            percent={percent}
                            autoIncrement={autoIncrement}
                            intervalTime={intervalTime}
                            spinner={false}
                        />
                        <Layout.Content className="main-container">
                            {children}
                            {
                                !noFooter &&
                                <Layout.Footer style={{backgroundColor: '#e3ecf6', color: '#000', padding: '0 0 0 60px'}}>
                                    {this.renderFooter()}
                                </Layout.Footer>
                            }
                        </Layout.Content>
                        {this.renderModalArticle()}
                    </div>
                </Layout>
            </DocumentTitle>
        )
    }
}


export default withNamespaces('translation')(MainLayout);
